<template class="full-height">
  <div class="socket-app-container" style="position: relative; height: 100%; padding: 10px">
    <el-tabs v-model="tabName" type="border-card">
      <el-tab-pane label="Socket即時監看" name="realTime">
        <div>
          <real-time></real-time>
        </div>
      </el-tab-pane>
      <el-tab-pane label="SdpLogs" name="logs">
        <div style="height: 100%">
          <sdp-logs></sdp-logs>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import RealTime from './components/socketRealTimeComponent.vue'
import SdpLogs from './components/sdpLogsComponent.vue'

export default {
  name: 'SocketInfo',
  components: {
    Pagination,
    RealTime,
    SdpLogs,
  },
  data() {
    return {
      tabName: 'realTime',
    }
  },
  async created() {},
  methods: {},
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}

.el-tabs--card {
  height: calc(100vh - 110px);
  /* overflow-y: auto; */
}
.el-tab-pane {
  height: calc(100vh - 110px);
  overflow-y: auto;
}
</style>
